import React, { useEffect, useState } from 'react';
import { Container, Spinner, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import api from '../api/API';

function formatarData(iso) {
  const data = new Date(iso);
  return data.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
}

function agruparPorDia(itens) {
  const grupos = new Map();
  itens.forEach((item) => {
    const chave = item.data_criacao.split('T')[0];
    if (!grupos.has(chave)) grupos.set(chave, []);
    grupos.get(chave).push(item);
  });
  return Array.from(grupos.entries());
}

const DiarioDesenvolvimentoPage = () => {
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);

  const carregar = async () => {
    try {
      const response = await api.get('/diario-desenvolvimento');
      setItens(response.data);
    } catch (error) {
      console.error('Erro ao carregar o diario de desenvolvimento:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar();
  }, []);

  const grupos = agruparPorDia(itens);

  return (
    <Container fluid className="p-4">
      <h4><FontAwesomeIcon icon={faBook} className="me-2" />Diário de Desenvolvimento</h4>
      <p className="text-muted">O que foi concluído em cada tarefa, na ordem em que foi documentado.</p>

      {loading ? (
        <Spinner animation="border" />
      ) : grupos.length === 0 ? (
        <p>Nenhuma tarefa documentada ainda.</p>
      ) : (
        grupos.map(([dia, entradas]) => (
          <section key={dia} className="mt-4">
            <h6 className="text-uppercase text-muted">{formatarData(entradas[0].data_criacao)}</h6>
            {entradas.map((item) => (
              <div key={item.id} className="p-3 border-bottom">
                <div className="d-flex justify-content-between align-items-start">
                  <strong>{item.tarefa}</strong>
                  {item.projeto && (
                    <Badge bg="secondary" style={item.projeto_cor ? { backgroundColor: item.projeto_cor } : undefined}>
                      {item.projeto}
                    </Badge>
                  )}
                </div>
                <p className="mb-0 mt-1">{item.comentario}</p>
              </div>
            ))}
          </section>
        ))
      )}
    </Container>
  );
};

export default DiarioDesenvolvimentoPage;
